<template>
    <v-container>
        <v-row>
            <v-col offset="1">
                <work-space-notify-config 
                    notify_type="ExportDebtUnAnswereds"
                    :default_configs="list_default_configs"
                ></work-space-notify-config>
            </v-col>
        </v-row>
        <v-row>
            <v-col offset="1">
                <organization-notifications :init_filters="{notify_class: 'ExportDebtUnAnswereds'}"/>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import WorkSpaceNotifyConfig from '@/app/components/workspace/notifications/WorkSpaceNotifyConfig.vue';
import OrganizationNotifications from '@/app/components/organization/OrganizationNotifications.vue';

const DEFAULT_CONFIGS = [
    {
        id: null,
        timezone: 'Europe/Moscow',
        time_at: '13:00',
        real_time_at: '16:00',
        notify_type: 'ExportDebtUnAnswereds',
        notify_description: 'Настройка времени уведомлений по новым запросам из Соцзащиты в ГИС ЖКХ'
    }
];
export default {
    name: 'SocialNotify',
    components:{
        WorkSpaceNotifyConfig, OrganizationNotifications
    },
    props:{
    },
    data () {
        return {
        }
    },
    created(){
    },
    watch:{

    },
    methods: {
    
    },
    computed:{
        list_default_configs(){
            return DEFAULT_CONFIGS;
        }
    }
}
</script>